import {IPatientVitalResponse} from "../../models/IPatientVitalResponse"
import * as React from "react"
import * as RoutesConfig from "../../routes"
import {IAppState} from "../../models/IAppState"
import {PatientCompleteInfoActions} from "../../actions/PatientCompleteInfoActions"
import IPatientVital from "../../models/IPatientVital"
import {connect} from "react-redux"
import IVital from "../../models/staticData/IVital"
import {AllStaticDataActions} from "../../actions/AllStaticDataActions"
import VitalsEditViewCont from "../EditView/VitalsEditViewCont"
import TodaysVitalsEditViewCont from "../EditView/TodaysVitalsEditViewCont";
import IAccountData from "../../models/IAccountData";
import AppUtils from "../../utils/AppUtils";
import CollapsibleCardView from "../../components/CollapsibleCardView";
import VitalsChartContainer from "../VitalsChartContainer";
import {metricIdsToFetchMetrics} from "../../utils/AppConstants";
import {EditViewDisplayMode} from "../../components/common/EditViewCard";

/* REQUIREMENT: All Patient Components should be within the parent component which has the patient profile */

/**
 * Created by abhinav on 27/01/18.
 */

export interface PatientVitalContainerProps {
    accountData: IAccountData,
    patientVitals: IPatientVitalResponse[],
    staticVitalList: IVital[],
    fetchPatientVitals: (patientId: number) => any,
    savePatientVitals: (patientId: number, patientVitals: IPatientVital[]) => any,
    fetchAllStaticData: () => any,
    params: any,
    curefitUserId: string
}

export interface PatientVitalContainerState {

}

class PatientVitalContainer extends React.Component<PatientVitalContainerProps, PatientVitalContainerState> {

    constructor(props: PatientVitalContainerProps) {
        super(props);
    }

    getPatientId = () => {
        return parseInt(this.props.params[RoutesConfig.PATIENT_ID_PARAM]);
    }


    render() {
        return (
            <div className="patient-info-section">
                <div className="patient-section-header">Vitals</div>
                <div className="patient-info-subsection surgery-section">
                    <TodaysVitalsEditViewCont displayMode={EditViewDisplayMode.VIEW} userId={Number(this.props.curefitUserId)} patientId={this.getPatientId()} staticVitalList={this.props.staticVitalList}
                                              patientVitals={this.props.patientVitals} fetchPatientVitals={this.props.fetchPatientVitals}
                                              savePatientVitals={this.props.savePatientVitals} fetchAllStaticData={this.props.fetchAllStaticData}
                                              showSummary={false} showCallapseButton={false} editedBy={AppUtils.getEditedBy(this.props.accountData)} metricIds={metricIdsToFetchMetrics} />
                </div>
                <div className="patient-info-subsection vitals-chart-section">
                    {
                        this.props.patientVitals &&
                        <CollapsibleCardView titleComponent={"Charts"} showCollapseButton={false}>
                            <VitalsChartContainer patientVitals={this.props.patientVitals} />
                        </CollapsibleCardView>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) =>  {
    return {
        accountData: state.accountData,
        patientVitals: state.patientCompleteInfo.vitals,
        staticVitalList: state.allStaticDataNew.vitalList,
        curefitUserId: state.patientCompleteInfo.profile.curefitUserId
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        fetchPatientVitals: (patientId: number, userId: number, metricIds: number[]) => {
            return PatientCompleteInfoActions.fetchPatientVitals(dispatch, patientId, userId, metricIds);
        },
        savePatientVitals: (patientId: number, patientVitals: IPatientVital[]) => {
            return PatientCompleteInfoActions.savePatientVitals(dispatch, patientId, patientVitals);
        },
        fetchAllStaticData: () => {
            return AllStaticDataActions.fetchAllStaticData(dispatch);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientVitalContainer);

